import { render } from "./Social.vue?vue&type=template&id=60cdd829"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"

import "./Social.vue?vue&type=style&index=0&id=60cdd829&lang=scss"

import exportComponent from "/Users/bhensonweb/Projects/ShannonHenson/henson-for-iowa/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__